module.exports = __webpack_public_path__ + "static/media/logo-white.d9683547.svg";